module.exports = __webpack_public_path__ + "static/media/TeacherLaughingWithStudents.a9a6ebc4.jpg";